<template>
    <div v-if="alert">
        <base-modal
            v-if="alert"
            hide-footer
            :title="$t('user_alert.title')"
            @close="$emit('close')"
        >
            <user-alert-editor
                :alert="alert"
                @alert-resolved="$emit('alertResolved')"
            />
        </base-modal>
    </div>
</template>

<script>
import UserAlertEditor from './UserAlertEditor'
import BaseModal from "@/components/BaseModal";
import UserAlert from "@/components/user/alert/UserAlert";

export default {
    name: "UserAlertEditorModal",
    components: {BaseModal, UserAlertEditor},
    props: {
        alert: {
            type: UserAlert,
            default: null
        }
    },
    emits: ['close', 'alertResolved'],
}
</script>

<style scoped>

</style>
